import { ExpiredOfflineObjectAsyncTimestampRemover } from 'src/app/services/immo-ip-placer-offline-changes/abstract/expired-offline-object-async-timestamp-remover';
import { ProjectToOtherTour } from './project-to-other-tour';

export class ExpiredProjectToOtherTourRemover extends ExpiredOfflineObjectAsyncTimestampRemover<
  number,
  ProjectToOtherTour
> {}
